import {
  getAverageFromRatingObject,
  getTimeDiff,
  makeFieldObject,
  getTimeString,
  forArrayLength,
} from "../misc/helperfuncs";

const getLeftGeneral = (boxType, objects, clicks = {}) => {
  var generalOptions = [
    makeFieldObject("points", { points: objects.general.points }, null, null),
    makeFieldObject(
      "rating",
      {
        icon: boxType.ratings.general.first.general.icon,
        name: boxType.ratings.general.first.general.name,
        rating: objects.general.ratings.general.first,
      },
      null,
      null
    ),
    makeFieldObject(
      "rating",
      {
        icon: boxType.ratings.general.second.general.icon,
        name: boxType.ratings.general.second.general.name,
        rating: objects.general.ratings.general.second,
      },
      null,
      null
    ),
    makeFieldObject("detailedNumber", {
      number: objects.general.time.durations,
      name: "Average Completion Time",
      icon: "/icons/icon_time.png",
      ending: `${getTimeString(objects.general.time.durations).text} `,
    }),
    makeFieldObject("globalActivity", {
      description: "Global Activity",
      active: objects.general.active,
      open: objects.general.active,
      saved: objects.general.saved,
    }),
  ];
  const goalOptions = [
    makeFieldObject("detailedNumber", {
      number: objects.general.time.estimate,
      name: "Average Time Estimate",
      icon: "/icons/icon_time.png",
      ending: `${getTimeString(objects.general.time.estimate).text} `,
    }),
  ];

  if (objects.general.type == "goal")
    generalOptions = generalOptions.concat(goalOptions);

  generalOptions.push(
    makeFieldObject("detailedButton", {
      id: objects.general.id,
      description: "Put In Active",
      activeButton: true,
      name: "active",
      boxType,
      onClick: clicks.moveToActive,
      image: "/icons/icon_active.png",
    })
  );

  return {
    position: "left",
    object: "general",
    type: objects.general.type,
    options: generalOptions,
  };
};

const getRightGeneral = (boxType, objects, clicks, handleBoxTypes) => {
  const options = [];
  forArrayLength(boxType.related.types, (relatedBoxType) => {
    options.push(
      makeFieldObject(
        "relatedView",
        {
          array: objects?.general[relatedBoxType],
          name: boxType.related.descriptions[relatedBoxType],
          type: handleBoxTypes.getSingularType(relatedBoxType),
        },
        clicks,
        null
      )
    );
  });
  return {
    position: "right",
    object: "general",
    type: objects.general.type,
    options,
  };
};

const getLeftOpen = (boxType, objects, onImageClicked) => {
  return {
    position: "left",
    object: "open",
    type: objects.general.type,
    options: [
      makeFieldObject(
        "images",
        { images: objects.open?.images ?? [], description: "Uploaded Images" },
        onImageClicked,
        null
      ),
      makeFieldObject("arrayInfo", {
        objectArray: objects.open?.actives ?? [],
        arrayAmount: "In Active",
        values: [
          {
            value: "minutes",
            icon: "/icons/icon_time.png",
            name: "time",
          },
        ],
        description: "In Active Info",
        icon: "/icons/icon_active.png",
      }),
      makeFieldObject("detailedNumber", {
        number: objects.open
          ? getTimeDiff(objects.open?.date.opened, Date.now()).minutes
          : "",
        name: "Time Open",
        icon: "/icons/icon_time.png",
        ending: `${
          objects.open
            ? getTimeString(
                getTimeDiff(objects.open.date.opened, Date.now()).minutes
              ).text
            : 0
        } `,
      }),
      makeFieldObject("detailedNumber", {
        name: "In Active",
        icon: "/icons/icon_time.png",
        ending: `${
          objects.open ? getTimeString(objects.open.minutes.open).text : ""
        } `,
      }),
      makeFieldObject("detailedNumber", {
        number: objects.open?.partners.length,
        name: "Partners",
        icon: "/icons/icon_player.png",
        ending: `${objects.open?.partners.length} partners`,
      }),
      makeFieldObject("description", {
        description: objects.open?.longDescription,
      }),
      makeFieldObject("moods", {
        moodObject: objects.open?.moods,
      }),
    ],
  };
};

const getRightOpen = (boxType, objects, clicks) => {
  const options = [
    makeFieldObject("detailedNumber", {
      boolean: objects.open?.private,
      name: "Is Private",
      icon: "/icons/icon_private.png",
      ending: `${objects.open?.private ? "Private" : "Public"}`,
    }),
    makeFieldObject("detailedNumber", {
      number: objects.open?.points.own,
      name: "Points Invested",
      icon: "/icons/icon_point.png",
      ending: `${objects.open?.points.own} points`,
    }),
    makeFieldObject("rating", {
      icon: boxType.ratings.active.first.icon,
      name: boxType.ratings.active.first.name,
      rating: getAverageFromRatingObject(
        objects.open?.rating.active.first ?? {}
      ),
    }),
    makeFieldObject("rating", {
      icon: boxType.ratings.active.second.icon,
      name: boxType.ratings.active.second.name,
      rating: getAverageFromRatingObject(
        objects.open?.rating.active.second ?? {}
      ),
    }),
    makeFieldObject("rating", {
      icon: boxType.ratings.general.first.general.icon,
      field: ["general", "first"],
      onClick: clicks.clickRated,
      name: boxType.ratings.general.first.personal.name,
      rating: objects.open?.rating.general.first,
    }),
    makeFieldObject("rating", {
      icon: boxType.ratings.general.second.general.icon,
      field: ["general", "second"],
      onClick: clicks.clickRated,
      name: boxType.ratings.general.second.personal.name,
      rating: objects.open?.rating.general.second,
    }),
    makeFieldObject("attached", {
      thoughts: {
        value: objects.open?.thoughts.length,
        onClick: clicks.openThoughts,
      },
      focuses: {
        value: objects.open?.focuses.length,
        onClick: clicks.openFocuses,
      },
      statements: {
        value: objects.open?.statements.length,
        onClick: clicks.openStatements,
      },
      reports: {
        value: objects.open?.reports.length,
        onClick: clicks.openReports,
      },
    }),
    makeFieldObject("detailedButton", {
      description: "Remove From Open",
      name: "active",
      onClick: clicks.removeFromOpen,
      id: "remove",
    }),
  ];
  return {
    position: "right",
    object: "open",
    type: objects.general.type,
    options,
  };
};

// completed
const getLeftSaved = (boxType, objects, clicks) => {
  const options = [
    makeFieldObject("detailedNumber", {
      name: "Opened",
      icon: "/icons/icon_open.png",
      ending: `${objects.saved?.opened} times`,
    }),
    makeFieldObject("detailedNumber", {
      name: boxType.completed,
      icon: "/icons/icon_checkmark.png",
      ending: `${objects.saved?.completed} times`,
    }),
    makeFieldObject("detailedNumber", {
      name: "Put In Active",
      icon: "/icons/icon_active.png",
      ending: `${objects.saved?.putInActive} times`,
    }),
    makeFieldObject("detailedNumber", {
      name: "Removed From Active",
      icon: "/icons/icon_rewind.png",
      ending: `${objects.saved?.removedFromActive} times`,
    }),
    makeFieldObject("detailedNumber", {
      name: "Is Private",
      icon: "/icons/icon_private.png",
      ending: `${objects.open?.private ? "Private" : "Public"}`,
    }),
    makeFieldObject("detailedButton", {
      description: "Remove From Saved",
      name: "active",
      onClick: clicks.removeFromSaved,
      id: "saved",
    }),
  ];
  return {
    position: "left",
    object: "saved",
    type: objects.general.type,
    options,
  };
};

const getRightSaved = (
  handleBoxTypes,
  boxType,
  objects,
  clicks,
  objectSelected
) => {
  if (objectSelected != "saved") return;

  const options = [];
  forArrayLength(boxType.related.types, (relatedType) => {
    const name = boxType.related.descriptions[relatedType];
    options.push(
      makeFieldObject(
        "relatedView",
        {
          array: objects.saved[relatedType],
          name,
          type: handleBoxTypes.getSingularType(relatedType),
          onClick: clicks.addRelated,
        },
        clicks,
        null
      )
    );
  });
  return {
    position: "right",
    object: "saved",
    type: objects.general.type,
    options,
  };
};

const getLeftHistory = (boxType, objects, clicks) => {
  const options = [];
  return {
    position: "left",
    object: "history",
    type: objects.general.type,
    options,
  };
};

const getRightHistory = (boxType, objects, clicks) => {
  const options = [];
  return {
    position: "right",
    object: "history",
    type: objects.general.type,
    options,
  };
};

const getFieldsOptions = (
  handleBoxTypes,
  boxType,
  position,
  object,
  type,
  objects,
  clicks,
  objectSelected
) => {
  const array = [
    getLeftGeneral(boxType, objects, clicks),
    getRightGeneral(boxType, objects, clicks, handleBoxTypes),
    getLeftOpen(boxType, objects, clicks),
    getRightOpen(boxType, objects, clicks),
    getLeftSaved(boxType, objects, clicks),
    getRightSaved(handleBoxTypes, boxType, objects, clicks, objectSelected),
    getLeftHistory(boxType, objects, clicks),
    getRightHistory(boxType, objects, clicks),
  ];
  const found = array.find(
    (element) =>
      element.position == position &&
      element.type == type &&
      element.object == object
  );
  return found ? found.options : found;
};

export default getFieldsOptions;
